// extracted by mini-css-extract-plugin
export default {"email_resend":"EmailReset_email_resend__ugztL","msg_tip":"EmailReset_msg_tip__HFc7X","done_img":"EmailReset_done_img__wiGjp"};